
import { Component, Vue } from 'vue-property-decorator';
import DataTable from './_DataTable.vue';
import DataDetail from './_DataDetail.vue';
import LogUtils from 'panda-log';

@Component({
  components: {
    DataTable,
    DataDetail,
  },
})
export default class TerminalImport extends Vue {
  private dynamComp = 'DataTable';
  private rowDetail = {};

  handleBack() {
    this.dynamComp = 'DataTable';
  }

  goInfo(obj: object) {
    this.rowDetail = obj;
    this.dynamComp = 'DataDetail';
  }
}
